import { useQuery } from "@tanstack/react-query";
import { useCanWrite } from "@/app/auth";
import { ROUTING_INVALIDATE, type RoutingReferences } from "@/app/routing";
import { useSave } from "@/app/useSave";
import { Alert, Button, Modal } from "@/ui";

/** 规则和模板共用未引用删除保护，刷新失败时不能依据旧缓存删除（D126）。 */
export function RoutingDelete<T extends { id: number; name: string }>({ row, noun, queryKey, resource, onClose }: {
  row: T; noun: string; queryKey: string;
  resource: { remove: (row: T) => Promise<void>; references: (id: number) => Promise<RoutingReferences> };
  onClose: () => void;
}) {
  const canWrite = useCanWrite();
  const refs = useQuery({ queryKey: [queryKey, "references", row.id], queryFn: () => resource.references(row.id), staleTime: 0, refetchOnMount: "always" });
  const used = !!refs.data && (refs.data.account_ids.length > 0 || refs.data.template_ids.length > 0);
  const blocked = refs.isFetching || !!refs.error || !refs.data || used;
  const save = useSave(() => resource.remove(row), { invalidate: ROUTING_INVALIDATE, message: `已删除未引用${noun}`, onSaved: onClose });
  return <Modal open title={`删除${noun} ${row.name}`} onClose={onClose} footer={save.warning ? <Button onClick={onClose}>关闭并重新读取</Button> : <><Button onClick={onClose}>取消</Button>{canWrite && <Button variant="primary" disabled={blocked || save.saving} onClick={() => save.save(undefined)}>确认删除</Button>}</>}>
    {refs.error && <Alert tone="danger" title="引用读取失败">{refs.error.message}，禁止删除。</Alert>}
    {save.error && <Alert tone="danger" title="删除失败">{save.error}。请关闭后重新读取。</Alert>}
    {save.warning && <Alert tone="warning" title="已删除，通知未完成">{save.warning}，勿重复提交。</Alert>}
    {refs.data && !refs.error && !refs.isFetching ? <p>当前引用：{refs.data.account_ids.length} 个账号、{refs.data.template_ids.length} 个模板。{used ? "包含停用和过期绑定，被引用对象不可删除。" : `此${noun}未被引用，删除不会自动解除任何绑定。`}</p> : <p>正在读取引用范围。</p>}
  </Modal>;
}
